import MaterialList from "./MaterialList";

module.exports = [
    {path: '/material/list', component: MaterialList, meta: {title: 'Media Library', group: 'common'}},
]
